import React, { useState, useEffect } from "react";
import HomeFooter from "../Home/Home/HomeFooter/HomeFooter";
import HomeFact from "../Home/Home/HomeFact/HomeFact";
import HomeHeader from "../Home/Home/HomeHeader/HomeHeader";
import AboutAppoinment from "./AboutAppoinment/AboutAppoinment";
import AboutArea from "./AboutArea/AboutArea";
import HomeThreeFaq from "../HomeThree/HomeThreeFaq/HomeThreeFaq";
import AboutTestimonial from "./AboutTestimonial/AboutTestimonial";
import { buscarServico } from "../../hooks/getService";

const SuplementacaoPosParto = () => {
  const [servicoData, setServicoData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const idArea = 2;
  const idServico = 10;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await buscarServico(idServico);
        if (data) {
          setServicoData(data);
        } else {
          console.error("Erro ao buscar dados do serviço.");
        }
      } catch (error) {
        console.error("Erro na requisição:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [idServico]);

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(valor);
  };

  const title = servicoData?.Nome || "Suplementação Pós-Parto";
  const descricao =
    "Este serviço é destinado às mulheres Olis que acabaram de ter filhos e também aquelas que estão em amamentação. A mulher pós parto necessita de um cuidado maior, tanto pelas alterações que ocorrem na gravidez e parto, quanto pela amamentação. Nós cuidaremos de você!";

  const precoAVista = servicoData?.Preco ? Number(servicoData.Preco) : 0;
  const parcela6x = servicoData?.Parcelas?.find(
    (p) => p.QuantidadeParcelas === 6
  )?.ValorParcela;
  const valorParcela6x = parcela6x ? Number(parcela6x) / 6 : 0;
  const price = servicoData
    ? `${formatarMoeda(precoAVista)} ou até 6x de ${formatarMoeda(
        valorParcela6x
      )}`
    : "Carregando preço...";

  const fatos = {
    titulo_fatos: "Renove-se após o parto",
    descricao_fatos:
      "A mulher Olis sabe que uma boa nutrição é o grande pilar para um pós parto saudável. Ela fornece os nutrientes necessários para reparar tecidos, fortalecer o sistema imunológico e promover a produção de leite materno.",
    subtitulos: [
      {
        titulo: "Amamente livremente",
        subtitulo:
          "Certos nutrientes, como vitaminas do complexo B e vitamina D, são importantes para a produção de leite materno de qualidade. A adequada  suplementação pode garantir que você tenha os nutrientes necessários para te ajudar no desafio da amamentação.",
      },
      {
        titulo: "Auto cuidado",
        subtitulo:
          "Cuidar da própria saúde, incluindo a suplementação de micronutrientes, é uma forma de autocuidado.  Você irá se sentir melhor física e emocionalmente durante essa fase de transição e grandes mudanças.",
      },
    ],
  };

  const passos = [
    {
      titulo: "Agendamento do serviço",
      descricao: "Escolha o melhor horário para você",
    },
    {
      titulo: "Recebimento do link de atendimento, via Whatsapp",
    },
    {
      titulo: "Consulta realizada por videochamada (~45 min)",
      descricao: "Aguarde o retorno",
    },
    {
      titulo:
        "Solicitação de exames e envio de prescrição médica, se necessário",
    },
    {
      titulo: "Recebimento da solicitação de exames laboratoriais",
      descricao: "Receba o link de atendimento",
    },
    {
      titulo: "Com resultado dos seus exames em mãos, agende a sua avaliação",
      descricao: "Receba o link de atendimento",
    },
    {
      titulo: "Recebimento da suplementação de micronutrientes via WhatsApp",
      descricao: "Realize os exames",
    },
    {
      titulo: "Acompanhamento via WhatsApp por 15 dias após consulta",
      descricao: "Receba o relatório médico",
    },
  ];

  const imgUrl = "img/services/Suplementacao.png";

  if (isLoading) {
    return (
      <>
        <HomeHeader />
        <div style={{ textAlign: "center", padding: "50px" }}>
          <h2>Carregando...</h2>
        </div>
        <HomeFooter />
      </>
    );
  }

  return (
    <>
      <HomeHeader />
      <AboutArea
        title={title}
        descricao={descricao}
        price={price}
        idArea={idArea}
        idServico={idServico}
        imgUrl={imgUrl}
      />
      <HomeFact fatos={fatos} />
      <AboutAppoinment passos={passos} />
      <AboutTestimonial />
      <HomeThreeFaq />
      <HomeFooter />
    </>
  );
};

export default SuplementacaoPosParto;
